import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { GlobalExclusionsDataProviderFactory } from '../factory/GlobalExclusionsDataProviderFactory';
import { GlobalExclusionsBaseDataProvider } from '../dataProvider/GlobalExclusionsBaseDataProvider';

export class GlobalExclusionsRepository extends BaseWebComponentRepository {
  public dataProviderFactory: GlobalExclusionsDataProviderFactory;
  public dataProvider: GlobalExclusionsBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new GlobalExclusionsDataProviderFactory(),
    });
  }

  async getDataForView(): Promise<any> {
    return this.dataProvider.getDataForView();
  }

  /**
   * Remove records
   * @param params
   */
  async removeRecords(params: any): Promise<{ success: boolean }> {
    return this.dataProvider.removeRecords(params);
  }

  /**
   * Update records
   * @param params
   */
  async updateRecords(params: any): Promise<{ success: boolean }> {
    return this.dataProvider.updateRecords(params);
  }

  async assignItemToMultipleLists(companyId, itemId, listsIds, override): Promise<{ success: boolean }> {
    let response;
    try {
      response = await this.dataProvider.assignItemToMultipleLists(companyId, itemId, listsIds, override);
    } catch (err) {
      console.error(err);
    }
    return response;
  }

  async assignMultipleItemsToMultipleLists(companyId, itemIds, listIds): Promise<{ success: boolean }> {
    let response;
    try {
      response = await this.dataProvider.assignMultipleItemsToMultipleLists(companyId, itemIds, listIds);
    } catch (err) {
      console.error(err);
    }
    return response;
  }
}
